import { useContext } from "react";
import algoliasearch from "algoliasearch/lite";
import AppGlobalsContext from "app/AppGlobalsContext";

export const ALGOLIA_HITS_PER_PAGE = 10;

const useAlgoliaSearch = () => {
	const { envVars } = useContext(AppGlobalsContext);

	const algoliaClient = algoliasearch(envVars?.ALGOLIA_APP_ID, envVars?.ALGOLIA_API_KEY);

	return {
		...algoliaClient,
		search(requests) {
			// Detect and handle empty search requests
			if (requests.every(({ params }) => params?.query?.length === 0)) {
				return Promise.resolve({
					results: requests.map(() => ({
						hits: [],
						nbHits: 0,
						nbPages: 0,
						page: 0,
						processingTimeMS: 0,
						hitsPerPage: 0,
						exhaustiveNbHits: false,
						query: "",
						params: "",
					})),
				});
			}

			return algoliaClient.search(requests);
		},
	};
};

export default useAlgoliaSearch;
